import { FormattedMessage } from 'react-intl';

interface Props {
  unit?: string;
  min: number;
  max: number;

  value: number;
}
export function MinMaxHint({ min, max, value, unit }: Props) {
  if (value < min || value > max) {
    return (
      <i className="text-warning fs-6">
        <FormattedMessage id="input.valueNotInRangeErrorMessage" values={{ min, max, unit }} />
      </i>
    );
  }
  return undefined;
}
